@if (alertMessages && alertMessages.length > 0) {
  <a
    class="emergency-alert"
    data-testid="open-emergency-alert-link"
    tabindex="0"
    (click)="isOpen = !isOpen"
    (keydown.enter)="isOpen = !isOpen"
  >
    <div class="content">
      <div
        class="emergency-message-header"
        [ngStyle]="{ 'margin-top': isOpen ? '2rem' : '.5rem', 'margin-bottom': isOpen ? '0' : '.5rem' }"
      >
        <mat-icon [svgIcon]="IconNames.ice_warning" />
        <span class="header-title">Driftsmeldinger ({{ alertMessages.length }})</span>
      </div>
      <div class="emergency-message-collapse-icon">
        <span>{{ isOpen ? 'Skjul' : 'Åpne' }}</span>
        <mat-icon [svgIcon]="isOpen ? IconNames.ice_chevron_up : IconNames.ice_chevron_down" />
      </div>
      @if (isOpen) {
        <div animate.enter="open-animation" animate.leave="close-animation" class="emergency-messages">
          @for (message of alertMessages; track message.alertId) {
            <div class="emergency-message">
              <div class="emergency-message-date">{{ message.datetime | date: 'dd. MMM yyyy HH:mm' }}</div>
              <div>{{ message.finalText }}</div>
            </div>
          }
        </div>
      }
    </div>
  </a>
}
